/**
 * ? @description : All Routes Component
 */

// Dependencies
import { Routes, Route } from "react-router-dom";

// Admin Components
import PrivateRoute from "../routes/utils/PrivateRoute";
import LoginNavBar from "../NavBar/LoginNavBar";
import SignupForm from "../Login/SignupForm";
import GetEmail from "../Login/GetEmail";
import ForgotPassword from "../Login/ForgotPassword";
import Dashboard from "../Container/Dashboard/Dashboard";
// import Callouts from "../Container/Callouts/Callouts";
import { CalloutsNew } from "../Container/Callouts/CalloutsNew"; //added by ram
import CategoryTab from "../Container/Category/CategoryTab";
import TeachersTab from "../Container/Category/teachers_tab/TeachersTab";
import StudentsTab from "../Container/Category/students_tab/StudentsTab";
import UnmappedTab from "../Container/Category/unmapped_tab/UnmappedTab";
import MappedTab from "../Container/Category/mapped_tab/MappedTab";
import TeacherTraining from "../Container/Category/teacher_training/TeacherTraining";
import TeacherByAdmin from "../Container/Category/teacher_by_admin/TeacherByAdmin";
import StudentByAdmin from "../Container/Category/student_by_admin/StudentByAdmin";
import Training from "../Container/Settings/Training";
// import TeacherTraining from "../Container/Settings/teacher_training/TeacherTraining";
import StudentTraining from "../Container/Settings/student_training/StudentTraining";
import Batch from "../Container/Settings/batch/Settings";
import ProfilePage from "../Common/ProfilePage";
import ChangePassword from "../Common/ChangePassword";
import FAQ from "../Common/FAQ";
import NotFoundPage from "./errorpage/NotFoundPage";

// SPOC Components
import TrainerProfiles from "../Container/Category/Spoc/training/TrainerProfiles";
import MappedProfiles from "../Container/Category/Spoc/mapped/MappedProfiles";

// Asset
import calloutsmessage from "../../assets/calloutmessage/callout-message.json";

//redux-store
import { useSelector } from "react-redux";
import SetMessageTemplates from "../Common/SetMessageTemplates";
import { ViewAdminSpocList } from "../Common/view_admin_spoc_list/ViewAdminSpocList";
import StudentLevelDetails from "../Container/Category/Spoc/mapped/StudentLevelDetails";
import TeacherForgotPassword from "../Login/TeacherForgotPassword";
import PrivacyPolicy from "../Common/PrivacyPolicy";
import CheckLogs from "../Common/CheckLogs";


function AllRoutes() {
  // * Roles Variables
  const userrole = useSelector(state => state.user.user.userrole);

    return (
      // <HashRouter basename="/AllRoutes">
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<LoginNavBar />} />
      <Route path="login" element={<LoginNavBar />} />
      <Route path="password/forgot" element={<GetEmail />} />
      <Route path="/login/password/forgot" element={<GetEmail />} />
      <Route path="password/reset" element={<ForgotPassword />} />
      <Route path ="/privacypolicy" element={<PrivacyPolicy/>}/>

      {/* Private Routes */}
      {userrole === "admin" && (

        <Route element={<PrivateRoute />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route
            path="callouts"
            element={<CalloutsNew message={calloutsmessage} />}
          />
          <Route path="category" element={<CategoryTab />}>
            <Route index element={<TeachersTab />} />
            <Route path="teachers" element={<TeachersTab />} />
            <Route path="students" element={<StudentsTab />} />
            <Route path="unmapped" element={<UnmappedTab />} />
            <Route path="mapped" element={<MappedTab />} />
            {/* <Route path="training/teachers" element={<TeacherTraining />} /> */}
            <Route path="create/teacher" element={<TeacherByAdmin />} />
            <Route path="create/student" element={<StudentByAdmin />} />
          </Route>

          <Route path="lte-session" element={<Training />}>
            {/* <Route index element={<StudentTraining />} /> */}
            {/* <Route path="teacher" element={<TeacherTraining />} /> */}
            {/* <Route path="student" element={<StudentTraining />} > */}
            {/* <Route index  path="student-level-details" element={<StudentLevelDetails />}/> */}
            {/* </Route> */}
            {/* <Route path="student-level-details" element={<StudentLevelDetails />}/> */}


            <Route index element={<Batch />} />
            <Route path="training/teachers" element={<TeacherTraining />} />
          </Route>
          <Route path="lte-session-student" element={<StudentTraining />}>
          </Route>
          <Route path="student-level-details" element={<StudentLevelDetails />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="admin/signup" element={<SignupForm />} />
          <Route path="password/change" element={<ChangePassword />} />
          <Route path="templates" element={<SetMessageTemplates />} />
          <Route path="check-logs" element={<CheckLogs />} />
          <Route path="faq" element={<FAQ />} />
          <Route path="/admin/list" element={<ViewAdminSpocList />} />
        </Route>

      )}


      {userrole === "spoc" && (

        <Route element={<PrivateRoute />}>
          <Route path="/spoc/training" element={<TrainerProfiles />} />
          <Route path="/spoc/mapped" element={<MappedProfiles />} />
          <Route path="/spoc/student-level-details" element={<StudentLevelDetails />} />
        </Route>

      )}

      <Route path="/teacher/password/reset" element={<TeacherForgotPassword />} />
      {/* Not Found Page Route */}
      <Route path="/*" element={<NotFoundPage />} />
    </Routes>
      // </HashRouter>

  );
}
export default AllRoutes;
